import areas from '../assets/json/areas.json';
import { regions, provinces, cities, barangays } from 'select-philippines-address';
// import api from './apiHelpers';

const roles = [
	{ key: 2, value: 'Admin' },
	{ key: 3, value: 'Maker' },
	{ key: 4, value: 'Checker' },
	{ key: 5, value: 'Approver' },
	{ key: 6, value: 'Default Customer User' },
];

const order_statuses = [
	{ key: 1, value: 'Pending' },
	{ key: 2, value: 'On Process' },
	{ key: 3, value: 'Approved with Invoice' },
];

const client_order_statuses = [
	{ key: 1, value: 'Order On Process - Pending' },
	{ key: 2, value: 'Order On Process - Checked' },
	{ key: 3, value: 'Order On Process - Pre-checked' },
	{ key: 4, value: 'Order On Process - Verified' },
	{ key: 5, value: 'Order On Process - Approved' },
	{ key: 8, value: 'Order approved - Awaiting Invoice No.' },
	{ key: 6, value: 'Completed' },
	{ key: 7, value: 'Cancelled' },
];

const shippingTypes = [
	{ key: 1, value: 'Deliver' },
	{ key: 2, value: 'Pick-up' },
	{ key: 3, value: 'Ex-plant' },
];

const popularCategories = [
	{ key: 1, value: 'Bars' },
	{ key: 2, value: 'Plywood' },
	{ key: 3, value: 'Board' },
	{ key: 4, value: 'Sheet' },
	{ key: 5, value: 'Pipe' },
	{ key: 6, value: 'Cement' },
	{ key: 7, value: 'Furring' },
	{ key: 8, value: 'Matting' },
	{ key: 9, value: 'Tube' },
	{ key: 15, value: 'Welding Rod' },
];

const product_status = [
	{ key: 1, value: 'Low Stock' },
	{ key: 2, value: 'In Stock' },
	{ key: 3, value: 'Out of Stock' }
];

const sizes = [
	{ key: 1, value: '2.0mm x (18mm)' },
	{ key: 2, value: '2.5mm x (25mm)' },
	{ key: 3, value: '2.0mm x (30mm)' },
	{ key: 4, value: '2.0mm x (38mm)' },
	{ key: 5, value: '10mm x 20' },
	{ key: 6, value: '10mm x 25' },
	{ key: 7, value: '10mm x 30' },
	{ key: 8, value: '10mm x 35' },
	{ key: 9, value: '10mm x 40' },
	{ key: 10, value: '04.5mm x 4 x 8' },
	{ key: 11, value: '05.0mm x 4 x 8' },
	{ key: 12, value: '9.0mm x 4 x 8' },
	{ key: 13, value: '.40mm x 8' },
	{ key: 14, value: '.40mm x 9' },
	{ key: 15, value: '.6mm x 3m' },
	{ key: 16, value: '0.4mm' },
	{ key: 17, value: '0.5mm x 2 x 3m' },
	{ key: 18, value: '1.5mm x 1 x 1' },
	{ key: 19, value: '1.5mm x 1 x 2' },
	{ key: 20, value: '1.5mm x 2 x 2' },
	{ key: 21, value: '2.5mm 2 x 4 x 8' },
	{ key: 22, value: '3.0mm 2 x 4 x 8' },
	{ key: 23, value: '3.5mm 2 x 4 x 8' },
	{ key: 24, value: '4.0mm 2 x 4 x 8' },
	{ key: 25, value: '4.5mm 2 x 4 x 8' },
];

const thickness = [
	{ key: 1, value: '1.0 MM' },
	{ key: 2, value: '2.5 MM' },
	{ key: 3, value: '3.0 MM' },
	{ key: 4, value: '3.5 MM' },
	{ key: 5, value: '4.0 MM' },
	{ key: 6, value: '4.5 MM' },
	{ key: 7, value: '5.0 MM' },
	{ key: 8, value: '6.0 MM' },
];

const warehouses = [
	{ key: 1, code: 'Panda', value: 'TEI Panacan' },
	{ key: 2, code: 'Lunar', value: 'TEI Lizada' },
];

const area_groups = [
	{ key: 1, value: 'Within City Limits' },
	{ key: 2, value: 'Eastern Mindanao' },
	{ key: 3, value: 'Southern Mindanao' },
	{ key: 4, value: 'Western Mindanao' },
];

const terms = [
	{ key: 1, value: 'COD' },
	{ key: 2, value: '1D' },
	{ key: 3, value: '7D' },
	{ key: 4, value: '15D' },
	{ key: 5, value: '30D' },
	{ key: 6, value: '45D' },
	{ key: 7, value: '60D' },
];

const supplier_warehouses = [
	{ key: 1, value: 'Apo' },
	{ key: 2, value: 'Conch' },
	{ key: 3, value: 'Davao Cement' },
	{ key: 4, value: 'Davao Golden' },
	{ key: 5, value: 'Emco Plywood' },
	{ key: 6, value: 'Federal' },
	{ key: 7, value: 'Holcim' },
	{ key: 8, value: 'James Hardie' },
	{ key: 9, value: 'Kirin' },
	{ key: 10, value: 'Megga' },
	{ key: 11, value: 'Megga GS' },
	{ key: 12, value: 'Mighty' },
	{ key: 13, value: 'Pacific Cement' },
	{ key: 14, value: 'Red Lion' },
	{ key: 15, value: 'Republic' },
	{ key: 16, value: 'San Josue' },
	{ key: 17, value: 'Sanjia Steel' },
	{ key: 18, value: 'SMWPI' },
	{ key: 19, value: 'Stallion' },
	{ key: 20, value: 'Steel Asia' },
	{ key: 21, value: 'Supreme' },
	{ key: 22, value: 'Titan' },
	{ key: 23, value: 'Union' },
	{ key: 24, value: 'Ventura Ply' },
];

const usages = [
	{ key: 1, value: 'Roofing' },
	{ key: 2, value: 'Ceiling' },
	{ key: 3, value: 'Concreting' },
	{ key: 4, value: 'Walling' },
	{ key: 5, value: 'Flooring' },
];

const businessTypes = [
	{ key: 1, value: 'Contractor' },
	{ key: 2, value: 'Personal Use' },
	{ key: 3, value: 'Hardware / Traders' },
];

const paymentMethods = [
	{
		bank: 'OTC',
		label: 'Over-the-counter',
		account: '',
		name: ''
	},
	{
		bank: 'BDO',
		label: 'BDO',
		account: '008378008047',
		name: 'Tenny Enterprises, Inc.'
	},
	{
		bank: 'BDONB',
		label: 'BDO Network Bank',
		account: '040590063103',
		name: 'Tenny Enterprises, Inc.'
	},
	{
		bank: 'METROBANK',
		label: 'Metrobank',
		account: '6687668029368',
		name: 'Tenny Enterprises, Inc.'
	},
	{
		bank: 'PNB',
		label: 'Philippines National Bank (PNB)',
		account: '408470001990',
		name: 'Tenny Enterprises, Inc.'
	},
];

// async function productCategories() {
// 	try {
// 		const response = await api.get('/categories');
// 		return (response.productCategories || []).filter(
// 			category => category.value !== 'Special Order'
// 		);
// 	} catch (error) {
// 		console.error(error);
// 		return [];
// 	}
// }

const productCategoriesEndpoint = 'https://api.tennyinc.com/api/client/product-categories';

async function productCategories() {
	try {
		const response = await fetch(productCategoriesEndpoint);

		if (!response.ok) {
			throw new Error('Failed to fetch product categories', { cause: response.status });
		}

		const data = await response.json();
		return (data.productCategories || []).filter(
			category => category.name !== 'Special Order'
		);
	} catch (error) {
		console.error(error);
		return [];
	}
}

async function productCategoriesWithImgLink() {
	try {
		const response = await fetch(productCategoriesEndpoint);

		if (!response.ok) {
			throw new Error('Failed to fetch product categories', { cause: response.status });
		}

		const data = await response.json();
		return (data.productCategories || []).filter(
			category => category.name !== 'Special Order'
		);
	} catch (error) {
		console.error(error);
		return [];
	}
}

export {
	roles, order_statuses, client_order_statuses, shippingTypes, popularCategories,
	productCategories, product_status, sizes, thickness, warehouses,
	area_groups, areas, terms, supplier_warehouses, usages, businessTypes,
	regions, provinces, cities, barangays, paymentMethods, productCategoriesWithImgLink
};